export enum TransactionStatus {
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  WAITING_WEBHOOK = 'WAITING_WEBHOOK',
  EXCHANGE_COMPLETED = 'EXCHANGE_COMPLETED',
  DEPOSIT_COMPLETED = 'DEPOSIT_COMPLETED',
  PAYMENT_COMPLETED = 'PAYMENT_COMPLETED',
  INTERNAL_TRANSFER_COMPLETED = 'INTERNAL_TRANSFER_COMPLETED',
}

export interface TransactionStatusLog {
  readonly status: TransactionStatus;
  readonly provider: string | null;
  readonly internal: boolean;
  readonly final: boolean;
  readonly createdAt: string;
}

export interface TransactionStatusLogResponse {
  readonly statusLogs: TransactionStatusLog[];
  readonly nextStatus: string[];
}
